<template>
    <v-dialog v-model="dialog" width="400">
        <template v-slot:activator="{props}">
            <slot name="activator" :props="props" />
        </template>
        <v-card>
            <v-card-title>{{ $t('confirm') }}</v-card-title>
            <v-card-actions class="justify-center">
                <v-btn variant="flat" color="error" @click="remove">{{ $t('delete') }}</v-btn>
                <v-btn variant="flat" @click="dialog = false">{{ $t('cancel') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script lang="ts">
    import {Vue, Component, Emit} from 'vue-facing-decorator'

    @Component({})
    export class DeleteWithConfirmation extends Vue {
        dialog = false

        @Emit()
        remove() {
            this.dialog = false
        }
    }

    export default DeleteWithConfirmation
</script>
